module.exports = __webpack_public_path__ + "img/8814d713-a2ec-444a-aae7-acc4eb504224.7b5d2f4c.png";